import React from "react";

const PrivacyPolicy = () => {
  return (
    <div>
      <div className="m-2 lg:m-10 w-auto">
        <div className="bg-mgray ">
          <div className="container mx-auto px-4 py-20">
            <h1 className="text-3xl text-mblack font-bold font-mfont mb-4">
              Privacy Policy
            </h1>

            <p className="mb-4 text-mblack font-mfont text-xl font-medium">
              » Making Minds Technologies is serious about the secrecy and
              safety of the credentials of its customers/clients/visitors. Our
              strong purpose is to keep their data safe.
            </p>

            <p className="mb-4 text-mblack font-mfont text-xl font-medium">
              » This privacy policy document contains a type of information that
              is collected by teammakingminds@gmail.com and how we use it.
            </p>

            <p className="mb-4 text-mblack font-mfont text-xl font-medium">
              » Our privacy notice defines that you agree to our terms and
              conditions while visiting our website. We own the right to delete
              modify or change the content of the website or this Privacy Policy
              any time for any reason without prior announcement. If you have
              additional questions or require more information about our Privacy
              Policy, do not hesitate to contact us through email at
              teammakingminds@gmail.com
            </p>

            <h2 className="text-2xl text-mblack font-mfont font-bold mb-2">
              Log Files
            </h2>

            <p className="mb-4 text-mblack font-mfont text-xl font-medium">
              »With the use of log files, Making Minds Technologies records the
              information of visitors when they visit the website. These log
              files are basically used for analyzing the movement and collecting
              the demographic details of the visitor on the site. The
              information collected in the log files includes Internet Protocol
              Addresses, Browser Type, and Internet Service Provider, date and
              time stamp, number of clicks, and so on.
            </p>

            {/* <ul className="list-disc font-mfont list-inside mb-4">
              <li className="font-mfont">Your name and contact information</li>
              <li className="font-mfont">Demographic information</li>
              <li className="font-mfont">
                Other information relevant to customer surveys and/or offers
              </li>
            </ul> */}

            <h2 className="text-2xl text-mblack  font-mfont font-bold mb-2">
              Tracking{" "}
            </h2>

            <p className="mb-4 text-mblack font-mfont text-xl font-medium">
              We use Facebook pixel, Google global site tag, Google analytics
              and other required tags to improve the performance of our website
              and to re-market visitors on different ad platforms who visited
              our website in past. Email open and link clicks can be tracked by
              our email marketing softwares or other tools that we may need to
              check the response of our email.
            </p>

            {/* <ul className="list-disc font-mfont list-inside mb-4">
              <li className="font-mfont">Internal record keeping</li>
              <li className="font-mfont">
                Improving our products and services
              </li>
              <li className="font-mfont">
                Sending promotional emails about new products, special offers,
                or other information which we think you may find interesting
              </li>
              <li className="font-mfont">
                From time to time, we may also use your information to contact
                you for market research purposes. We may contact you by email,
                phone, or mail. We may use the information to customize the
                website according to your interests.
              </li>
            </ul> */}

            <h2 className="text-2xl text-mblack font-mfont font-bold mb-2">
              Consent
            </h2>

            <p className="mb-4 font-mfont text-mblack text-xl font-medium">
              » Visiting our website means you agree on all the terms and
              conditions of our privacy policy.
            </p>

            <h2 className="text-2xl text-mblack font-mfont font-bold mb-2">
              Cookies
            </h2>

            <p className="mb-4 text-mblack font-mfont text-xl font-medium">
              A cookie is a small file that asks permission to be placed on your
              computer's hard drive. Once you agree, the file is added, and the
              cookie helps analyze web traffic or lets you know when you visit a
              particular site. Cookies allow web applications to respond to you
              as an individual. The web application can tailor its operations to
              your needs, likes, and dislikes by gathering and remembering
              information about your preferences.
            </p>

            <p className="mb-4 text-mblack font-mfont text-xl font-medium">
              Overall, cookies help us provide you with a better website by
              enabling us to monitor which pages you find useful and which you
              do not. A cookie in no way gives us access to your computer or any
              information about you, other than the data you choose to share
              with us.
            </p>

            <h2 className="text-2xl text-mblack font-mfont font-bold mb-2">
              Contact
            </h2>

            <p className="mb-4 text-mblack font-mfont text-xl font-medium">
              » If you visit our website, requested a quote, filled our lead
              form or newsletter form or provided your details by any other way.
              We can contact you to tell you more about our services, show you
              remarketing ads or email you to tell you more about our services,
              offers or information.
            </p>

            <h2 className="text-2xl text-mblack font-mfont font-bold mb-2">
              Copyright
            </h2>

            <p className="mb-4 text-mblack   font-mfont text-xl font-medium">
              » We own a copyright on this privacy policy. If any customers
              found overstepping the terms and conditions of this policy would
              be subject to legal action.
              <br />
              This Privacy Policy can change at any time to either include or
              exclude clauses and Making Minds Technologies does not bear
              responsibility for updating Users on the same.
            </p>

            {/* <ul className="list-disc font-mfont list-inside mb-4">
              <li>
                If you have previously agreed to us using your personal
                information for direct marketing purposes, you may change your
                mind at any time by writing to or emailing us at [email
                protected]
              </li>
              <li className="font-mfont">
                We will not sell, distribute, or lease your personal information
                to third parties unless we have your permission or are required
                by law to do so. We may use your personal information to send
                you promotional information about third parties which we think
                you may find interesting if you tell us that you wish this to
                happen.
              </li>
              <li className="font-mfont">
                You may request details of personal information which we hold
                about you. If you would like a copy of the information held on
                you, please write to [Your Company Name, Address, City, State,
                Zip Code] or email [email protected]
              </li>
              <li className="font-mfont">
                If you believe that any information we are holding on you is
                incorrect or incomplete, please write to or email us as soon as
                possible at the above address. We will promptly correct any
                information found to be incorrect.
              </li>
            </ul> */}

            <p className="mb-4 font-mfont text-mblack text-xl font-medium">
              This privacy policy is subject to change without notice.
            </p>
          </div>
        </div>
      </div>

      {/* <div class="bg-blue-100 dark:bg-gray-800 relative shadow-md sm:rounded-lg overflow-hidden p-10 m-2">
        <div class="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-5 md:space-x-1.5 p-1.5">
          <div className="px-0 py-4 grid gap-3 md:flex md:justify-between md:items-center  border-gray-200 dark:border-gray-700">
            <h2 className="text-3xl font-bold uppercase text-gray-800 dark:text-gray-200"></h2>
          </div>
        </div>

        <h2>
          <p className="text-2xl font-semibold mb-3"></p>

          <p className="text-2xl font-semibold mb-3"></p>

          <p className="text-2xl font-semibold mb-5"></p>
        </h2>

        <h2 className="text-3xl font-bold mb-3 text-black uppercase"></h2>

        <h2 className="text-2xl font-semibold mb-3"></h2>

        <h2 className="text-3xl font-bold mb-3 text-black uppercase "></h2>

        <h2 className="text-2xl font-semibold mb-3"></h2>

        <h2 className="text-3xl font-bold mb-3 text-black uppercase">
          Third Party Privacy Policies
        </h2>

        <h2 className="text-2xl font-semibold mb-3 ">
          » This privacy policy page is the sole proprietorship of Making Minds Technologies
          Technologies and does not apply to other advertisers or websites.
          Thus, we are recommending you to consult the respective Privacy
          Policies of these third-party ad servers for more accurate
          information. It may include their individual practices and
          instructions about how to opt-out of certain options. You can choose
          to disable cookies through your individual browser options.
        </h2>

        <h2 className="text-3xl font-bold mb-3 text-black uppercase"></h2>
        <h2 className="text-2xl font-semibold mb-3"></h2>

        <h2 className="text-3xl font-bold mb-3 text-black uppercase">
          
        </h2>
        <h2 className="text-2xl font-semibold mb-3">
        
        </h2>

        <h2 className="text-3xl font-bold mb-3 text-black uppercase">
          
        </h2>
        <h2 className="text-2xl font-semibold mb-20">
        
        </h2>
      </div> */}
    </div>
  );
};

export default PrivacyPolicy;
